import * as l from "react";
import d from "react";
import { pickersSlideTransitionClasses as p, dayPickerClasses as u, pickersCalendarHeaderClasses as c, DatePicker as m } from "@mui/x-date-pickers";
import { outlinedInputClasses as n, dialogActionsClasses as C } from "@mui/material";
import { t as a } from "./theme-6ffbc8e6.js";
import { s as b } from "./styled-38387a7e.js";
import "./createTheme-02ce03eb.js";
import "@emotion/styled";
import "@emotion/react";
const i = (e) => e, f = () => {
  let e = i;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = i;
    }
  };
}, g = f(), y = g, h = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function k(e, t, r = "Mui") {
  const o = h[t];
  return o ? `${r}-${o}` : `${y.generate(e)}-${t}`;
}
function w(e, t, r = "Mui") {
  const o = {};
  return t.forEach((s) => {
    o[s] = k(e, s, r);
  }), o;
}
const x = w("MuiPickersArrowSwitcher", ["root", "spacer", "button"]), $ = (e) => /* @__PURE__ */ l.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("g", { id: "Icons/today_24px" }, /* @__PURE__ */ l.createElement("path", { id: "icon", fillRule: "evenodd", clipRule: "evenodd", d: "M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3 4.9 3 6V20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V9H19V20ZM6.5 13C6.5 11.62 7.62 10.5 9 10.5C10.38 10.5 11.5 11.62 11.5 13C11.5 14.38 10.38 15.5 9 15.5C7.62 15.5 6.5 14.38 6.5 13Z", fill: "#0A78CD" }))), R = b(M)(({ theme: e }) => ({
  [`.${n.root}`]: {
    color: e.palette.blue.c100,
    width: "320px",
    backgroundColor: e.palette.common.white,
    [`.${n.notchedOutline}`]: {
      borderColor: e.palette.blue.c20
    }
  }
})), H = {
  color: (e) => e.palette.darkBlue.c100,
  [`.${p.root}`]: {
    button: {
      color: (e) => e.palette.darkBlue.c100,
      ...a.typography.body2,
      ["&.Mui-selected"]: {
        color: (e) => e.palette.common.white
      },
      "&[aria-current]:not(.Mui-selected)": {
        backgroundColor: a.palette.blue.c5,
        border: "none"
      }
    }
  },
  [`.${C.root}`]: {
    button: {
      color: (e) => e.palette.blue.c100,
      textDecoration: "underline",
      textTransform: "capitalize",
      ...a.typography.button2
    }
  },
  [`.${u.weekDayLabel}`]: {
    color: (e) => e.palette.darkBlue.c100,
    ...a.typography.body2
  }
}, V = {
  [`.${c.label}`]: {
    ...a.typography.body2
  },
  [`.${c.switchViewButton}`]: {
    color: (e) => e.palette.blue.c100
  },
  [`.${x.button}`]: {
    color: (e) => e.palette.blue.c100
  }
};
function M({ placeholder: e, slotProps: t, ...r }) {
  const o = {
    textField: { placeholder: e },
    layout: {
      sx: H
    },
    calendarHeader: { sx: V }
  };
  return /* @__PURE__ */ d.createElement(m, { slots: { openPickerIcon: $ }, slotProps: { ...o, ...t }, ...r });
}
export {
  R as default
};
